<ng-template #actionButton>
  <iris-button
    [type]="IrisButtonTypes.PRIMARY"
    (click)="reviewedCostEstimation()"
    data-test="self-pay-cost-estimation-next-button"
  >
    Next
  </iris-button>
</ng-template>

@if (ratesLoading()) {
  <div class="rates-loading" data-test="self-pay-rates-loading">
    <iris-spinner [size]="'sm'"></iris-spinner>
  </div>
} @else {
  <div class="cost-estimation-container">
    <div class="estimated-session-cost-card" data-test="estimated-session-cost-card">
      <h2 class="estimated-session-cost-heading" [class.direct-booking-estimated-session-cost-heading]="fromDirectBooking()" >Estimated session cost</h2>

      @if (fromDirectBooking()) {
        <div class="single-rate-display" data-test="self-pay-single-rate">
          <h1 class="single-rate-amount">{{ (featuredEstimates()[0]?.amount != null && featuredEstimates()[0]?.amount !== 0) ? (featuredEstimates()[0].amount | currency:'USD':'symbol':'1.0-2') : 'N/A' }}</h1>
          <p>For a 60 minute intake session</p>
        </div>
      } @else {
        <ul class="featured-estimates-list">
          @for (estimate of featuredEstimates(); track estimate.serviceLabel + estimate.amount) {
            <li class="featured-estimate-row">
              <div class="featured-estimate-label-block">
                <p class="featured-estimate-service">{{ estimate.serviceLabel }}</p>
              </div>
              <h2 class="featured-estimate-amount">{{ (estimate.amount != null && estimate.amount !== 0) ? (estimate.amount | currency:'USD':'symbol':'1.0-2') : 'N/A' }}</h2>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  @if (!fromDirectBooking()) {
    <p class="insurance-note" data-test="self-pay-insurance-note">
      You can add health insurance or other benefits anytime in your account.
    </p>
  }

  <client-self-pay-cost-estimate-detailed [rates]="rates()" />
}

@if (!fromDirectBooking()) {
  <iris-button-container [alignment]="IrisButtonContainerAlignments.END">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
  </iris-button-container>
}
